import {
  Stepper,
  Step,
  StepLabel,
  Card,
} from "@mui/material";
import { CardStyle } from "./style";
import { useEffect, useRef } from "react";

const steps = [
  "Идея",
  "Планирование",
  "Реализация",
  "Тестирование",
  "Работает",
  "Завершён",
];

type StepperDescriptionProps = {
  indexNumber: number
}

export const StepperDescription = ({indexNumber}: StepperDescriptionProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const activeStepRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => { 
    if (containerRef.current && activeStepRef.current) { 
      const container = containerRef.current; 
      const active = activeStepRef.current; 
      
      const containerCenter = container.offsetWidth / 2; 
      const activeCenter = active.offsetLeft + active.offsetWidth / 2; 
      
      container.scrollTo({ 
        left: activeCenter - containerCenter, 
        behavior: "auto", 
      }); 
    } 
  }, [indexNumber]);

  return (
    <Card ref={containerRef} variant="primaryAdaptiveCard" sx={CardStyle}>
      <Stepper activeStep={indexNumber - 1} alternativeLabel sx={{ width: "694px" }}>
        {steps.map((label, i) => (
          <Step 
            key={label}
            ref={i === indexNumber - 1 ? activeStepRef : null}
          >
            <StepLabel>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Card>
  )
}
